import type { IndustryContent } from '@/types/content';
import { getTestimonialsByIndustry } from '../testimonials';

export const roofingContent: IndustryContent = {
  slug: 'roofing',
  name: 'Roofing',
  headline: 'The Operating System for Roofing Contractors',
  subheadline:
    'Manage estimates, coordinate crews, and handle storm seasons—all from one platform built for roofing professionals.',
  heroImageUrl: '/images/industries/roofing-hero.webp',
  painPoints: [
    {
      title: 'Storm season overwhelms your team',
      description:
        'When hail hits, leads pour in faster than you can handle. Jobs get lost, follow-ups slip, and competitors scoop your customers.',
      icon: 'storm',
    },
    {
      title: 'Estimates take forever',
      description:
        "You're driving back to the office to build quotes. By the time you send it, the homeowner has three other bids.",
      icon: 'clock',
    },
    {
      title: 'Crew coordination is a nightmare',
      description:
        'Multiple crews, different job sites, materials deliveries—one missed call and the whole day falls apart.',
      icon: 'chaos',
    },
    {
      title: 'Insurance claims slow everything down',
      description:
        'Tracking supplements, approvals, and payments across dozens of jobs buries your office in paperwork.',
      icon: 'paperwork',
    },
  ],
  features: [
    {
      title: 'Storm Response Mode',
      description:
        'Capture and prioritize leads during peak demand. Automated follow-ups ensure no opportunity slips through the cracks.',
      icon: 'storm',
    },
    {
      title: 'Mobile Estimating',
      description:
        'Build professional estimates on-site with satellite measurements, material calculators, and instant customer approval.',
      icon: 'estimate',
    },
    {
      title: 'Crew Scheduling Board',
      description:
        'See all crews, job sites, and material deliveries on one board. Drag-and-drop scheduling with automatic notifications.',
      icon: 'dispatch',
    },
    {
      title: 'Insurance Claim Tracking',
      description:
        'Track every claim from inspection to final payment. Supplement tracking, approval workflows, and payment reconciliation.',
      icon: 'insurance',
    },
    {
      title: 'Photo Documentation',
      description:
        'Capture before, during, and after photos organized by job. Time-stamped and GPS-tagged for insurance requirements.',
      icon: 'camera',
    },
    {
      title: 'Material Management',
      description:
        'Track orders, deliveries, and on-site inventory. Never show up to a job site without the right materials again.',
      icon: 'inventory',
    },
  ],
  testimonial: getTestimonialsByIndustry('roofing')[0],
  stats: [
    { label: 'Faster Estimate Turnaround', value: '4x' },
    { label: 'More Jobs Per Crew', value: '+40%' },
    { label: 'Lead Response Time', value: '<15min' },
    { label: 'Claim Processing Time', value: '-50%' },
  ],
  seo: {
    title: 'Roofing Contractor Software | Estimates & Crew Management | Omniforge',
    description:
      'Roofing software built for contractors. Mobile estimating, crew scheduling, insurance claim tracking, and storm response tools. Start your free trial.',
    keywords: [
      'roofing contractor software',
      'roofing estimating software',
      'roofing crm',
      'roofing business software',
      'roofing scheduling software',
      'storm damage roofing software',
    ],
  },
};
